import React from 'react';
import { Loader } from '../../components/loader/Loader';
import styles from './entity_decision_loader.module.scss';

export function EntityDecisionLoader() {
  return (
    <div className={styles.spinner}>
      <Loader size={30} />
    </div>
  );
}
